import {Injectable} from '@angular/core';
import {PartnerModel} from '../model/partner.model';
import {PartnerRepository} from '../../impl/service/ngrx/partner.repository';
import {PartnerDataServiceAdapter} from '../../impl/service/ngrx/partnerDataService.adapter';
import {AbstractFindOneByIdService} from '../../../../core/service/v2/service/findone/abstractFindOneById.service';

@Injectable()
export class PartnerFindOneByIdService extends AbstractFindOneByIdService<PartnerModel, PartnerModel>{
    constructor(repository: PartnerRepository, dataServiceAdapter: PartnerDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

}
